import { render, staticRenderFns } from "./administratorsListItem.vue?vue&type=template&id=5f0bfec0&"
import script from "./administratorsListItem.vue?vue&type=script&lang=js&"
export * from "./administratorsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports